module.exports = __webpack_public_path__ + "media/images/pic/workshops/kazdy-tego-slucha-ac489a362f6f9cba190da4f8ab462e62.jpeg";